import { Injectable } from '@angular/core';
import {Subject} from "rxjs/Subject";

@Injectable()
export class PaymentModalService {

  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();

  constructor() { }

  public notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }

  public finishModal(data: any={action:'finish'}) {
    if (data) {
      this.notify.next(data);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/payment-modal.service.ts